import reducer from './reducer'

import * as feesOperations from './operations'
import * as feesSelectors from './selectors'

export { feesOperations, feesSelectors }

export default reducer
